export function isItemPersisted(item) {
  return (
    Object.prototype.hasOwnProperty.call(item, 'isPersisted') &&
    !item.isPersisted
  );
}

export function containsTemporaryFile(files) {
  return files.some(isItemPersisted);
}
